export { default } from 'react-bootstrap/CloseButton';
